import React from 'react';
import { useNavigate } from 'react-router-dom';
import './News.css';
import img86 from '../../Assets/photo/86.png';
import img85 from '../../Assets/photo/85.png';
import img87 from '../../Assets/photo/87.png';

const News = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className="news-page">
      {/* Back Header */}
      <div className="back-header">
        <button className="back-btn" onClick={handleBack}>
          <span>←</span> Back
        </button>
      </div>

      {/* News Container */}
      <div className="news-container">
        <h2>Latest Posts & Announcements</h2>

        <div className="news-flex">
          {/* Telegram */}
          <a 
            className="news-card" 
            href="https://t.me/biomenewsupdates" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img src={img86} alt="Telegram" />
            <div className="news-label">Tele (Community & Dev News)🧑‍💻</div>
          </a>

          {/* Instagram */}
          <a 
            className="news-card" 
            href="https://www.instagram.com/biome_com?igsh=MnJjdGljNmFiOHF6" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img src={img85} alt="Instagram" />
            <div className="news-label">Instagram✨</div>
          </a>

          {/* TikTok */}
          <a 
            className="news-card" 
            href="https://www.tiktok.com/@solatastic?_r=1&_t=ZS-921AecS3CWy" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img src={img87} alt="TikTok" />
            <div className="news-label">Tiktok✨</div>
          </a>
        </div>

        <p className="reach-out-text">Reach out to us below</p>

        {/* Email Section */}
        <div className="emails">
          <div className="email-item">
            <strong>Business Enquiries:</strong>
            <a href="mailto:biome_bizenquiries@gmail.com">biome_bizenquiries@gmail.com</a>
          </div>

          <div className="email-item">
            <strong>Support:</strong>
            <a href="mailto:supportlinehelp_biome@gmail.com">supportlinehelp_biome@gmail.com</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default News;
